module.exports = __webpack_public_path__ + "img/3_2022TerryFoxRun_LongSleeveTShirt.d7cf1858.png";